import React from "react";
import { Accordion, AccordionSet, MultiColumnList, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import css from "./reports.module.css";
export var Kult1501ReportResults = function (_a) {
    var data = _a.data;
    var _b = useIntl(), formatMessage = _b.formatMessage, formatNumber = _b.formatNumber;
    var fmt = function (n) { return formatNumber(n); };
    var mdtFormatter = {
        rowNumber: function (row) { return row.rowNumber; },
        groupName: function (row) { return row.groupName; },
        books: function (row) { return fmt(row.books); },
        brochures: function (row) { return fmt(row.brochures); },
        total: function (row) { return fmt(row.total); },
        firstEdBooks: function (row) { return fmt(row.firstEdBooks); },
        firstEdBrochures: function (row) { return fmt(row.firstEdBrochures); },
        firstEdTotal: function (row) { return fmt(row.firstEdTotal); },
        eTitles: function (row) { return fmt(row.eTitles); },
        audioTitles: function (row) { return fmt(row.audioTitles); },
    };
    var languageFormatter = {
        languageCode: function (row) { return row.languageCode; },
        languageName: function (row) { var _a; return (_a = row.languageName) !== null && _a !== void 0 ? _a : ""; },
        printedTotal: function (row) { return fmt(row.printedTotal); },
        printedLiterary: function (row) { return fmt(row.printedLiterary); },
        eTotal: function (row) { return fmt(row.eTotal); },
        eLiterary: function (row) { return fmt(row.eLiterary); },
        audioTotal: function (row) { return fmt(row.audioTotal); },
        audioLiterary: function (row) { return fmt(row.audioLiterary); },
    };
    var mdtColumnMapping = {
        rowNumber: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.rowNumber",
        }),
        groupName: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.groupName",
        }),
        books: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.books",
        }),
        brochures: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.brochures",
        }),
        total: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.total",
        }),
        firstEdBooks: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.firstEdBooks",
        }),
        firstEdBrochures: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.firstEdBrochures",
        }),
        firstEdTotal: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.firstEdTotal",
        }),
        eTitles: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.eTitles",
        }),
        audioTitles: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.audioTitles",
        }),
    };
    var languageColumnMapping = {
        languageCode: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.languageCode",
        }),
        languageName: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.languageName",
        }),
        printedTotal: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.printedTotal",
        }),
        printedLiterary: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.printedLiterary",
        }),
        eTotal: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.eTotal",
        }),
        eLiterary: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.eLiterary",
        }),
        audioTotal: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.audioTotal",
        }),
        audioLiterary: formatMessage({
            id: "ui-br-agency.outputs.kult-15-01.column.audioLiterary",
        }),
    };
    var mdtColumns = [
        "rowNumber",
        "groupName",
        "books",
        "brochures",
        "total",
        "firstEdBooks",
        "firstEdBrochures",
        "firstEdTotal",
        "eTitles",
        "audioTitles",
    ];
    var languageColumns = [
        "languageCode",
        "languageName",
        "printedTotal",
        "printedLiterary",
        "eTotal",
        "eLiterary",
        "audioTotal",
        "audioLiterary",
    ];
    return (React.createElement("div", { className: css.resultsWrapper },
        React.createElement("h3", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.kult-15-01.results.title", values: { year: data.year } })),
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.outputs.kult-15-01.section.partI",
                }), open: true },
                React.createElement(MultiColumnList, { contentData: data.mdtRows, formatter: mdtFormatter, visibleColumns: mdtColumns, columnMapping: mdtColumnMapping, interactive: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.outputs.kult-15-01.section.partII",
                }) },
                React.createElement(MultiColumnList, { contentData: data.languageRows, formatter: languageFormatter, visibleColumns: languageColumns, columnMapping: languageColumnMapping, interactive: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.outputs.kult-15-01.section.partIII",
                }) },
                React.createElement(MultiColumnList, { contentData: data.translationRows, formatter: languageFormatter, visibleColumns: languageColumns, columnMapping: languageColumnMapping, interactive: false })))));
};
